import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon12",
  "use": "icon-home-item-icon12-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon12\">\n<g>\n\t<path d=\"M11.7,2.1H4.5c-0.5,0-1,0.4-1,1v14c0,0.5,0.4,1,1,1h11c0.5,0,1-0.4,1-1V6.8C16.5,6.8,11.7,2.1,11.7,2.1z M8.1,4.1\n\t\tc0.9,0,1.5,0.7,1.5,1.5S8.9,7.2,8.1,7.2S6.5,6.5,6.5,5.6S7.2,4.1,8.1,4.1z M8.1,7.4c1.2,0,2.2,0.9,2.2,1.9c0,0.3-0.2,0.5-0.5,0.5\n\t\tS9.3,9.6,9.3,9.4c0-0.5-0.6-1-1.2-1s-1.2,0.4-1.2,1c0,0.3-0.2,0.5-0.5,0.5S5.9,9.6,5.9,9.4C5.9,8.3,6.9,7.4,8.1,7.4z M13.6,15.3\n\t\tH6.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h7.2c0.3,0,0.5,0.2,0.5,0.5C14.1,15.1,13.9,15.3,13.6,15.3z M13.6,12.9H6.4\n\t\tc-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h7.2c0.3,0,0.5,0.2,0.5,0.5C14.1,12.7,13.9,12.9,13.6,12.9z M12.5,6.3\n\t\tc-0.1,0-0.2-0.1-0.2-0.2V4.1l2.2,2.2C14.6,6.3,12.5,6.3,12.5,6.3z\" />\n\t<path d=\"M8.1,6.3c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7S7.4,5.2,7.4,5.6C7.4,6,7.7,6.3,8.1,6.3z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon12.svg
// module id = yMAh
// module chunks = 97